import token from '@uipath/apollo-core/lib';
export const MuiInputLabel = (palette) => {
    return {
        root: {
            margin: `${token.Padding.PadL} 0`,
            fontWeight: token.FontFamily.FontWeightSemibold,
            fontSize: token.FontFamily.FontMSize,
            lineHeight: token.FontFamily.FontMLineHeight,
            color: palette.semantic.colorForegroundDeEmp,
            '&.select-label': { '& + .MuiInputBase-root > .MuiOutlinedInput-notchedOutline': { top: '0px !important' } },
            '&.Mui-error': { color: palette.semantic.colorErrorText },
            '& + .MuiInputBase-root > .MuiOutlinedInput-notchedOutline': { top: '-5px !important' },
            '&.Mui-focused': { color: palette.semantic.colorForegroundDeEmp },
        },
    };
};
